module.exports = __webpack_public_path__ + "img/104023.d28bcd02.png";